import type { ExactTheme } from "src/lib/emotion/theme.ts";
import { css } from "@emotion/react";

export const root =
  ({ maxItemsUploaded }: { maxItemsUploaded: boolean }) =>
  (theme: ExactTheme) =>
    css({
      color: theme.colorsV2.grey[800],
      margin: 0,
      fontSize: theme.fontSizesV2.body,
      padding: "10px 15px",
      borderTop: maxItemsUploaded
        ? "none"
        : `1px solid ${theme.colorsV2.grey[100]}`,
    });
